var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMastercard(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 33.563,
    height: 20.608,
    viewBox: "0 0 33.563 20.608",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "mastercard",
    transform: "translate(-0.605)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_114",
    "data-name": "Path 114",
    d: "M20.986,18.235H11.91V2.033h9.076Z",
    transform: "translate(0.94 0.169)",
    fill: "#ff5f00"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_115",
    "data-name": "Path 115",
    d: "M13.426,10.3a10.263,10.263,0,0,1,3.961-8.1,10.332,10.332,0,1,0-6.41,18.405,10.371,10.371,0,0,0,6.41-2.2,10.262,10.262,0,0,1-3.961-8.1",
    transform: "translate(0)",
    fill: "#eb001b"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_116",
    "data-name": "Path 116",
    d: "M32.881,10.3a10.386,10.386,0,0,1-16.782,8.1,10.263,10.263,0,0,0,0-16.2,10.386,10.386,0,0,1,16.782,8.1",
    transform: "translate(1.288)",
    fill: "#f79e1b"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMastercard);
export default __webpack_public_path__ + "static/media/mastercard.1374da8dca7c694bf5ecb1df5359a383.svg";
export { ForwardRef as ReactComponent };